module.exports = __webpack_public_path__ + "static/media/IconPlus.4472343e.svg";